import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { getSiteHostname } from "@/lib/config";

const HomePage              = lazy(() => import("@/pages/HomePage"));
const FeaturesPage          = lazy(() => import("@/pages/FeaturesPage"));
const DashboardPage         = lazy(() => import("@/pages/DashboardPage"));
const AttendancePage        = lazy(() => import("@/pages/AttendancePage"));
const KidsPage              = lazy(() => import("@/pages/KidsPage"));
const StaffPage             = lazy(() => import("@/pages/StaffPage"));
const FoodMenuPage          = lazy(() => import("@/pages/FoodMenuPage"));
const GalleryPage           = lazy(() => import("@/pages/GalleryPage"));
const NotificationsPage     = lazy(() => import("@/pages/NotificationsPage"));
const PaymentsPage          = lazy(() => import("@/pages/PaymentsPage"));
const SchedulePage          = lazy(() => import("@/pages/SchedulePage"));
const ActivityFeedPage      = lazy(() => import("@/pages/ActivityFeedPage"));
const HolidaysPage          = lazy(() => import("@/pages/HolidaysPage"));
const LostAndFoundPage      = lazy(() => import("@/pages/LostAndFoundPage"));
const ReportsPage           = lazy(() => import("@/pages/ReportsPage"));
const FindDaycaresPage      = lazy(() => import("@/pages/FindDaycaresPage"));
const MessagesPage          = lazy(() => import("@/pages/MessagesPage"));
const ParentNotificationsPage = lazy(() => import("@/pages/ParentNotificationsPage"));
const PricingPage           = lazy(() => import("@/pages/PricingPage"));
const ParentAppPage         = lazy(() => import("@/pages/ParentAppPage"));
const DaycareManagementPage = lazy(() => import("@/pages/DaycareManagementPage"));
const AboutPage             = lazy(() => import("@/pages/AboutPage"));
const ContactPage           = lazy(() => import("@/pages/ContactPage"));
const BlogPage              = lazy(() => import("@/pages/BlogPage"));
const BlogArticlePage       = lazy(() => import("@/pages/BlogArticlePage"));
const FaqPage               = lazy(() => import("@/pages/FaqPage"));
const BookDemoPage          = lazy(() => import("@/pages/BookDemoPage"));
const LoginPage             = lazy(() => import("@/pages/LoginPage"));
const NotFoundPage          = lazy(() => import("@/pages/NotFoundPage"));

if (typeof window !== "undefined") {
  const siteHostname = getSiteHostname();
  const wwwHostname = `www.${siteHostname}`;
  if (window.location.hostname === wwwHostname) {
    window.location.replace(
      window.location.href.replace(`://${wwwHostname}`, `://${siteHostname}`),
    );
  }
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Suspense fallback={<div className="min-h-screen bg-[#F4ECE0]" />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/attendance" element={<AttendancePage />} />
              <Route path="/kids" element={<KidsPage />} />
              <Route path="/staff" element={<StaffPage />} />
              <Route path="/food-menu" element={<FoodMenuPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/payments" element={<PaymentsPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/activity-feed" element={<ActivityFeedPage />} />
              <Route path="/holidays" element={<HolidaysPage />} />
              <Route path="/lost-and-found" element={<LostAndFoundPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/find-daycares" element={<FindDaycaresPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/parent-notifications" element={<ParentNotificationsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/parent-app" element={<ParentAppPage />} />
              <Route path="/daycare-management" element={<DaycareManagementPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/book-demo" element={<BookDemoPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
